import { RadioSwatchGroup_Field_default } from "./chunk-KW4MZ7JT.js";
import { RadioSwatchGroup_default } from "./chunk-QXANNIJF.js";
import { RadioSwatchGroup_MoreButton_default } from "./chunk-Q6PBGZUV.js";

// src/components/RadioSwatchGroup/index.ts
var RadioSwatchGroupComponent = RadioSwatchGroup_default;
RadioSwatchGroupComponent.Field = RadioSwatchGroup_Field_default;
RadioSwatchGroupComponent.Field.displayName = "RadioSwatchGroup.Field";
RadioSwatchGroupComponent.MoreButton = RadioSwatchGroup_MoreButton_default;
RadioSwatchGroupComponent.MoreButton.displayName = "RadioSwatchGroup.MoreButton";
export { RadioSwatchGroupComponent };